export const PUBLIC_AUTH_ENDPOINTS = [
  '/loginUser',
  '/find/user',
  '/user/reset_password',
  '/business/user/forget_password',
  '/user/verify/code',
  '/user/password/update',
  '/password/update/initial/onborading',
];

export const isPublicAuthUrl = (requestUrl = '') => {
  try {
    const pathname = new URL(requestUrl, 'http://localhost').pathname.replace(/\/+$/, '');
    return PUBLIC_AUTH_ENDPOINTS.some((endpoint) => pathname.endsWith(endpoint));
  } catch (_error) {
    return false;
  }
};

export const normalizeResetEmail = (email = '') => email.trim().toLowerCase();

export const isValidResetEmail = (email = '') => {
  const normalizedEmail = normalizeResetEmail(email);
  return normalizedEmail.length > 0
    && normalizedEmail.length <= 254
    && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
};

export const sanitizeOtpDigit = (value = '') => value.replace(/\D/g, '').slice(-1);

export const readSixDigitOtp = (value = '') => {
  const digits = value.replace(/\D/g, '').slice(0, 6);
  return digits.length === 6 ? digits : null;
};
